import React, { useState } from "react";

const Policy = () => {
  return (
    <>
      <section>
        <div className="max-container">
          <div className="padd-90">
            {/* <h2 className="roboto-bold mb40 heading29px text-color-131415 text-center">
              Privacy Policy
            </h2> */}

            <p className="text-right roboto-regular heading16px mb40 text-color-131415">
              Effective Date: 7th April 2025
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              At <strong>BeyondLeadz</strong>  (“we,” “our,” or “us”), we are committed to safeguarding your privacy and the confidentiality of your business data. This Privacy Policy explains how we collect, use, and protect the information you provide when using our website, platform, and related services (collectively, the “Services”).
              <br />
              <br />
              By using BeyondLeadz, you agree to the terms of this policy.

            </p>

            <p className="heading20px roboto-bold mb10">
              Information We Collect
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              We collect information that you voluntarily provide, including your name, email, phone number, company details, lead and campaign data, and billing information. This information is collected when you create an account, use the platform, contact support, or participate in a trial or promotion.
              <br /> <br />
              Please note: BeyondLeadz does not use cookies or tracking tools to collect personal or technical information for marketing or profiling purposes. Any system-level logs (e.g., IP addresses) used for platform security or diagnostics are not linked to individual users.
            </p>

            <p className="heading20px roboto-bold mb10">How Your Information Is Used</p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              The information you provide is used to: <br /> <br />
              1. Operate and manage your BeyondLeadz account <br />
              2. Deliver the platform’s features and functionality <br />
              3. Provide customer support and respond to inquiries <br />
              4. Process payments for paid services
              <br />
              5. Share updates or service-related notifications

              <br /> <br />

              All customer data, including lead or contact lists, is encrypted and inaccessible to us — therefore, it cannot be used for marketing, resale, or any form of repurposing.

            </p>

            <p className="heading20px roboto-bold mb10">
              Data Sharing
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              We do not sell or share your personal or customer-identifiable data. <br /> <br />
              We may share limited, non-personal information with trusted service providers (e.g., cloud infrastructure or billing partners) strictly for operational purposes. These providers receive only what is required to perform their services and are bound by confidentiality and data protection agreements.
              <br /> <br />
              We do not share lead data, customer contact details, or campaign content with any third party.
            </p>

            <p className="heading20px roboto-bold mb10">
              Data Retention
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              We retain your data only as long as necessary to provide our services and meet legal, contractual, or operational requirements. You may request deletion of your data at any time by contacting us.
            </p>

            <p className="heading20px roboto-bold mb10">
              Your Privacy Rights
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              Depending on your jurisdiction, you may have the right to access, update, delete, or request a copy of your personal data. You may also withdraw consent or object to certain types of data processing.
              <br /> <br />
              To make a privacy request, please contact us at: <a style={{ color: "#5d44ff", textDecoration: "underline" }} href="mailto:contact@beyondleadz.ai">contact@beyondleadz.ai</a>

            </p>

            <p className="heading20px roboto-bold mb10">Data Security</p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              We use industry-standard security practices to protect your data, including encryption, secure access controls, and regular infrastructure audits. Your data is stored and processed in secure environments to prevent unauthorized access or misuse.
            </p>

            <p className="heading20px roboto-bold mb10">
              International Use
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              BeyondLeadz may be accessed globally. By using our services, you consent to the transfer and processing of your data in countries where our platform and partners operate, in compliance with applicable laws.
            </p>

            <p className="heading20px roboto-bold mb10">Children’s Privacy
            </p>

            <p className="roboto-regular heading16px mb40 text-color-131415">
              BeyondLeadz is a business-to-business (B2B) service and not intended for individuals under the age of 18. We do not knowingly collect or store personal information from children.
            </p>

            <p className="heading20px roboto-bold mb10">Policy Updates
            </p>

            <p className="roboto-regular heading16px text-color-131415 mb40">
              We may update this Privacy Policy from time to time. If we make significant changes, we will notify you via the platform or email. Continued use of the Services constitutes your acceptance of the revised policy.
            </p>

            <p className="heading20px roboto-bold mb10">Contact Us
            </p>

            <p className="roboto-regular heading16px text-color-131415">
              If you have any questions or concerns about this Privacy Policy, or if you’d like to make a data-related request, please contact:
              <br /><br />
              <strong>BeyondLeadz</strong> <br />
              Email: <a style={{ color: "#5d44ff", textDecoration: "underline" }} href="mailto:contact@beyondleadz.ai">contact@beyondleadz.ai</a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default Policy;
